(() => {
  const optionName = '名入れオプション';
  const enabledValuePrefix = 'あり';

  function getSelectedOptionValue(scope) {
    const optionGroups = scope.querySelectorAll('.product-form__input');

    for (const group of optionGroups) {
      const legend = group.querySelector('legend');
      const label = group.querySelector('label.form__label');
      const displayedName = (legend || label)?.textContent.trim();

      if (displayedName !== optionName) {
        continue;
      }

      const checkedInput = group.querySelector(
        'input[type="radio"]:checked, input[type="checkbox"]:checked'
      );

      if (checkedInput) {
        return checkedInput.value;
      }

      const select = group.querySelector('select');

      if (select) {
        return select.value;
      }
    }

    return '';
  }

  function initializePersonalizationField(field) {
    if (field.dataset.personalizationInitialized === 'true') {
      return;
    }

    const input = field.querySelector('[data-personalization-input]');

    if (!input) {
      return;
    }

    const form = input.form;

    const scope =
      field.closest('[id^="MainProduct-"]') ||
      field.closest('.shopify-section') ||
      document;

    function isPersonalizationEnabled() {
      const selectedValue = getSelectedOptionValue(scope);
      return selectedValue.startsWith(enabledValuePrefix);
    }

    function updateFieldVisibility() {
      const isEnabled = isPersonalizationEnabled();

      field.hidden = !isEnabled;
      input.disabled = !isEnabled;
      input.required = isEnabled;

      if (!isEnabled) {
        input.value = '';
        input.setCustomValidity('');
        input.removeAttribute('aria-invalid');
      }
    }

    function validatePersonalization() {
      if (!isPersonalizationEnabled()) {
        input.setCustomValidity('');
        input.removeAttribute('aria-invalid');
        return true;
      }

      if (input.value.trim() === '') {
        input.setCustomValidity('刺繍するお名前を入力してください。');
        input.setAttribute('aria-invalid', 'true');
        return false;
      }

      input.setCustomValidity('');
      input.removeAttribute('aria-invalid');
      return true;
    }

    input.addEventListener('input', () => {
      const sanitizedValue = input.value.replace(/[^A-Za-z -]/g, '');

      if (input.value !== sanitizedValue) {
        input.value = sanitizedValue;
      }

      if (input.value.trim() !== '') {
        input.setCustomValidity('');
        input.removeAttribute('aria-invalid');
      }
    });

    scope.addEventListener('change', (event) => {
      if (event.target.closest('variant-selects')) {
        window.setTimeout(updateFieldVisibility, 0);
      }
    });

    if (form && form.dataset.personalizationValidationAdded !== 'true') {
      form.addEventListener(
        'submit',
        (event) => {
          if (!validatePersonalization()) {
            event.preventDefault();
            event.stopImmediatePropagation();

            input.reportValidity();
            input.focus();
          }
        },
        true
      );

      form.dataset.personalizationValidationAdded = 'true';
    }

    field.dataset.personalizationInitialized = 'true';
    updateFieldVisibility();
  }

  function initializeAllPersonalizationFields(root = document) {
    root
      .querySelectorAll('[data-personalization-field]')
      .forEach(initializePersonalizationField);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initializeAllPersonalizationFields();
    });
  } else {
    initializeAllPersonalizationFields();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeAllPersonalizationFields(event.target);
  });
})();